import { ObjectSelectInput, ObjectSelectProps } from '@frontend/components/basic-forms';
import { DocumentClient } from '@frontend/document/api';
import { Document, DocumentQueryParams } from '@frontend/document/types';
import { CommonMessage } from '@frontend/lang';
import React, { useState } from 'react';

const ID = 'document-select';
export const DocumentSelect = (props: ObjectSelectProps<Document, DocumentQueryParams>) => {
    const [v, cV] = useState<Document | null>(null);
    return (
        <ObjectSelectInput<Document, DocumentQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            label={props.label || CommonMessage.OBJECTS.DOCUMENT.DEFAULT}
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            required={props.required}
            queryParams={props.queryParams}
            value={v}
            idValue={props.value || v?.id}
            fetch={(arg) => DocumentClient.fetchDocuments(arg)}
            singleFetch={(id) => DocumentClient.resolveDocuments([id]).then((res) => res.results[0])}
            itemLabel={(document) => document.name}
            disabled={props.disabled}
            isClearable={props.isClearable}
        />
    );
};
